import React from 'react';
const Header = () => {
    return (
        <>
            <h1 className='header'>Blurb Books</h1>
        </>
    );
};
export default Header;